import { List, ListProps, SearchInput } from 'react-admin';

import { AppResponsive } from 'shared/components/common/AppResponsive.component';
import { Pagination } from 'shared/components/pagination/Pagination.component';

import { RaListOrder } from 'shared/services/backoffice-data-provider';

import { ActivitiesTabbedDatagrid } from '../components/ActivitiesTabbedDatagrid.component';

import { ActivitiesTable } from '../components/ActivitiesTable.component';

export function ActivitiesList(props: ListProps) {
  return (
    <List
      {...props}
      perPage={100}
      sort={{ field: 'display_name', order: RaListOrder.ASC }}
      pagination={<Pagination />}
      filters={[<SearchInput source='search' alwaysOn />]}
      exporter={false}
    >
      <AppResponsive
        xs={<ActivitiesTable omitItems={[]} />}
        sm={<ActivitiesTable omitItems={[]} />}
        md={<ActivitiesTable omitItems={[]} />}
        lg={<ActivitiesTabbedDatagrid />}
        xl={<ActivitiesTabbedDatagrid />}
      />
    </List>
  );
}
